import * as types from './types';
import { MutationTree } from 'vuex';
import { UiState } from '@/types';

const mutations: MutationTree<UiState> = {
  [types.TOGGLE_LEGAL_MESSAGE](state, shouldShow) {
    state.isLegalMessageDisplayed = shouldShow;
  },
  [types.TOGGLE_MOBILE_MENU](state, shouldShow) {
    state.isMobileMenuDisplayed = shouldShow;
  },
  [types.TOGGLE_NEW_PRODUCT_MODAL](state, shouldShow) {
    state.isNewProductModalDisplayed = shouldShow;
  },
  [types.TOGGLE_USER_INVITATION_MODAL](state, shouldShow) {
    state.isUserInvitationModalDisplayed = shouldShow;
  },
  [types.SET_NEWS_BANNER](state, data) {
    state.news = data;
  },
  [types.TOGGLE_DELETE_CONFIRMATION](state, shouldShow) {
    state.isDeleteConfirmationDisplayed = shouldShow;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/ui/mutations.ts